import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { MANGAWHAI_REEL, TRAVEL_TIMES, fadeUp, fadeIn, openViewing } from './data';
import { useAutoAdvance } from './useAutoAdvance';

const TravelTimes = () => (
  <motion.div {...fadeUp}>
    <p className="text-[#d6cdb4] text-xs tracking-[0.2em] uppercase mb-6">Approximate drive times</p>
    <ul className="divide-y divide-white/15 border-y border-white/15">
      {TRAVEL_TIMES.map((t, i) => (
        <li key={t.place} className="flex justify-between gap-6 py-4 text-base" data-testid={`travel-time-${i}`}>
          <span className="text-white/85">{t.place}</span>
          <span className="text-white whitespace-nowrap">{t.time}</span>
        </li>
      ))}
    </ul>
    <p className="text-white/65 text-xs leading-relaxed mt-4">Times are approximate and depend on route and traffic.</p>
  </motion.div>
);

export const LocationSection = () => {
  const index = useAutoAdvance(MANGAWHAI_REEL.length, 5500);

  return (
    <section id="location" className="py-20 md:py-28 bg-[#3d4f3c]" data-testid="mangawhai-section">
      <SectionHeading eyebrow="Location">
        Mangawhai Heads, <span className="italic font-accent">and the golf coast</span>
      </SectionHeading>

      <div className="max-w-6xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-start">
        <motion.div {...fadeIn} className="lg:col-span-3 relative overflow-hidden bg-black aspect-[4/3]">
          <AnimatePresence mode="sync">
            <motion.img
              key={index}
              src={MANGAWHAI_REEL[index]}
              alt="Mangawhai coastline"
              initial={{ opacity: 0, scale: 1.06 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 1.03 }}
              transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
              className="absolute inset-0 w-full h-full object-cover"
            />
          </AnimatePresence>
        </motion.div>

        <div className="lg:col-span-2 space-y-10">
          <motion.div {...fadeUp} className="space-y-4 text-white/85 text-base leading-relaxed">
            <p>
              The 126 sits within The Sanctuary — a gated, 100-hectare coastal community of 55 lots with
              tennis courts, olive groves and bush walks, looking across the valley to the Brynderwyn Ranges.
            </p>
            <p>
              Te Arai Links and Tara Iti lie a short drive south. Course access, membership and playing
              rights are subject to each club's own arrangements and are not included with the property.
            </p>
          </motion.div>
          <TravelTimes />
          <button
            type="button"
            onClick={() => openViewing('viewing')}
            data-testid="location-viewing-btn"
            className="text-[#d6cdb4] text-sm tracking-[0.12em] uppercase border-b border-[#d6cdb4]/60 pb-1 hover:text-white hover:border-white transition-colors"
          >
            In the area? Arrange a viewing
          </button>
        </div>
      </div>
    </section>
  );
};
